import { render, staticRenderFns } from "./ChannelAddCustomPostTemplateModal.vue?vue&type=template&id=d323450e&scoped=true&"
import script from "./ChannelAddCustomPostTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./ChannelAddCustomPostTemplateModal.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelAddCustomPostTemplateModal.vue?vue&type=style&index=0&id=d323450e&scoped=true&lang=scss&"
import style1 from "./ChannelAddCustomPostTemplateModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d323450e",
  null
  
)

export default component.exports